<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-reconnaissance-arm-france-quebec/"
    paramsName="ARM_France"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component
        :is="path"
        :sas="sas"
        @validation-changed="setState(path, $event)"
        :ref="path"
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"
import Identification from "@/components/Formulaires/DemandeReconnaissanceArmFranceQuebec/Identification"
import OrdresProfessionnels from "@/components/Formulaires/DemandeReconnaissanceArmFranceQuebec/OrdresProfessionnels"
import Diplomes from "@/components/Formulaires/DemandeReconnaissanceArmFranceQuebec/Diplomes"
import EquivalenceStage from "@/components/Formulaires/DemandeReconnaissanceArmFranceQuebec/EquivalenceStage"
import Cheminement from "@/components/Formulaires/DemandeReconnaissanceArmFranceQuebec/Cheminement"
import Declaration from "@/components/Formulaires/DemandeReconnaissanceArmFranceQuebec/Declaration"
import DeclarationsJudiciaires from "@/components/form_parts/DeclarationsJudiciaires"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-reconnaissance-arm-france-quebec",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "diplomes", code: "titre-etape-2", state: "" },
        { path: "ordres-professionnels", code: "titre-etape-3", state: "" },
        { path: "EquivalenceStage", code: "titre-etape-4", state: "" },
        { path: "Cheminement", code: "titre-etape-5", state: "" },
        { path: "declarations-judiciaires", code: "titre-etape-6", state: "" },
        { path: "Declaration", code: "titre-etape-7", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Identification,
    Diplomes,
    OrdresProfessionnels,
    EquivalenceStage,
    Cheminement,
    Declaration,
    DeclarationsJudiciaires
  }
}
</script>

<style></style>
